import { DASH, ZERO } from '@constants';

export const wrapLongWords = (sentence: string, maxLength: number) => {
  const words = sentence.split(' ');
  const result: string[] = [];

  words.forEach((word) => {
    while (word.length > maxLength) {
      result.push(word.slice(ZERO, maxLength) + DASH);
      word = word.slice(maxLength);
    }
    result.push(word);
  });

  return result.join(' ');
};
